export default __webpack_public_path__ + "static/media/image-main-2-w.1a4630f9.webp";